let intersectionObserverAvailable = false;

if ('IntersectionObserver' in window &&
    'IntersectionObserverEntry' in window &&
    'intersectionRatio' in window.IntersectionObserverEntry.prototype) {
    intersectionObserverAvailable = true;

    // Minimal polyfill for Edge 15's lack of `isIntersecting`
    // See: https://github.com/w3c/IntersectionObserver/issues/211
    if (!('isIntersecting' in window.IntersectionObserverEntry.prototype)) {
        Object.defineProperty(window.IntersectionObserverEntry.prototype,
            'isIntersecting', {
                get: function () {
                    return this.intersectionRatio > 0;
                },
            });
        intersectionObserverAvailable = true;
    }
}

export default function scrollObserver(querySelector, callback) {
    let target = document.querySelectorAll(querySelector);
    if (intersectionObserverAvailable) {
        let observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    callback(entry.target);
                    observer.unobserve(entry.target);
                }
            });
        });

        target.forEach(el => {
            observer.observe(el);
        });
    } else {
        // no intersection observer API is available, so let's just load it all now instead of doing nothing
        target.forEach(el => {
            callback(el);
        });
    }
}
